import { render } from "./AdminUserJourneys.vue?vue&type=template&id=4a1b831c"
import script from "./AdminUserJourneys.vue?vue&type=script&lang=js"
export * from "./AdminUserJourneys.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__